export enum GTMPageType {
    ACCOUNT_REGISTRATION = 'account_registration',
    ACCOUNT_FORGOT_PASSWORD = 'account_forgot_password',
    ACCOUNT_RESET_PASSWORD = 'account_reset_password',
    CATEGORY = 'category',
    CHECKOUT_LOGIN = 'checkout_login',
    CHECKOUT_SHIPPING = 'checkout_shipping',
    CHECKOUT_BILLING = 'checkout_billing',
    CHECKOUT_REVIEW = 'checkout_review',
    PDP = 'product_detail',
    PLP = 'product_listing',
    SEARCH = 'search_listing',
    STORE_PAGE = 'store_page',
    SHOPPING_BAG = 'shopping_bag',
    PRODUCT_COMPARISON = 'product_comparison',
    OTHER = 'other',
}
